import cardSb from './card-sb4for3.vue'
import cardSkClub from './card-sk-club.vue'
import cardGeneric from './card-generic.vue'
export default {
    name: 'card',
    components:{cardSb,cardSkClub,cardGeneric},
    props: {
        path: String,
        title: String,
        cardNumber: String,
        type: String,
        joined: Boolean,
        linked: Boolean,
        loading:{type:Boolean,default:false},
        isDisabled:Boolean,
        disabled:Boolean,
        genericMessage:String,
        activationLink:String,
        moreInfoLink:String,
    },
    data() {
        return {
            showConfirmReplaceCard: false,
        }
    },

    computed:{
        activated(){
            return this.linked && this.joined;
        }
    },


    methods: {

        link(cardNumber){
            this.$emit('link',cardNumber)
        },

        join(){
            this.$emit('join');
        },

        replaceCard() {
            // console.log("replace card functionality")
        },

        // showConfirmReplaceCard() {
        //     this.showConfirmReplaceCard = true
        // },

    }
}


// WEBPACK FOOTER //
// ./src/components/profile/card/card.js